module.exports = __webpack_public_path__ + "static/img/navbar_bg.97cde9b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lifePay/navbar_bg.png
// module id = fl7+
// module chunks = 2